import $ from 'jquery'
import includes from 'lodash-es/includes'
import headerUtils from 'http-headers-validation'
import { isURL } from './helpers'
import { Forms } from './forms'
import { MessageOverlay } from './message-overlay'

const Webhooks = {
  init: function () {
    $(document).on('click', '.js-test-hook', Webhooks.test)
    $(document).on('change', '.js-webhook-select', Webhooks.changeTestEvent)
    $(document).on('submit', '.js-webhook-form', Webhooks.save)
    $(document).on('change', '.js-webhook-event', Webhooks.selectEvent)
  },

  /**
   * Form submit event
   */
  save: function (event) {
    event.preventDefault()
    const errors = []

    // Validate headers
    function removeHeaderError($el) {
      $el.removeClass('is-invalid').removeAttr('aria-invalid')
    }

    $('.js-webhook-header').each(function (index, el) {
      const $key = $(el).find('.u-input[data-type="key"]')
      const $value = $(el).find('.u-input[data-type="value"]')

      // Ignore validation if both fields are blank
      if ($key.val() === '' && $value.val() === '') {
        // Remove existing errors
        removeHeaderError($key)
        removeHeaderError($value)
        return
      }

      if (headerUtils.validateHeader($key.val(), $value.val())) {
        removeHeaderError($key)
        removeHeaderError($value)
      } else {
        errors.push('header')
        $key.addClass('is-invalid').attr('aria-invalid', 'true')
        $value.addClass('is-invalid').attr('aria-invalid', 'true')

        if (!$('.js-webhook-header-error').length) {
          $('.js-field-manage')
            .find('.c-form-row')
            .last()
            .append(
              '<div class="c-form-row_error js-webhook-header-error"><p>Please enter a valid header.</p></div>'
            )
        }
      }
    })

    // Remove header error label if there are no errors
    if (!includes(errors, 'header')) {
      $('.js-webhook-header-error').remove()
    }

    // Validate webhook URL
    const $url = $('.js-webhook-url')
    if (isURL($url.val())) {
      Forms.removeError($url.parents('.c-form-row'))
    } else {
      errors.push('url')
      Forms.showError(
        $url.parents('.c-form-row'),
        'Please enter a valid webhook URL.'
      )
    }

    // Validate events
    const $events = $('.js-webhook-event:checked')
    if ($events.length) {
      Forms.removeError($('.js-webhook-event').parents('.c-form-row'))
    } else {
      errors.push('events')
      Forms.showError(
        $('.js-webhook-event').parents('.c-form-row'),
        'Please select at least 1 event.'
      )
    }

    if (errors.length) {
      // Expand the settings panel if it's closed and if there are header errors
      if (
        includes(errors, 'header') &&
        !$('.webhook-advanced_content').is(':visible')
      ) {
        $('.js-expand').trigger('click')
      }

      // Scroll to the top of the page
      $('html, body').animate({ scrollTop: 0 })

      // Enable the submit button
      $(this).find('input[type="submit"]').prop('disabled', false)
    } else {
      $('.js-webhook-form')[0].submit()
    }
  },

  /**
   * Toggle additional options when selecting events
   */
  selectEvent: function () {
    const currentEvent = $(this).data('event')

    // Find matching options container
    const $options = $(
      '.js-webhook-event-option[data-event="' + currentEvent + '"]'
    )

    // Toggle the option and deselect
    $options
      .slideToggle(250)
      .find('input[type="checkbox"]')
      .prop('checked', false)
  },

  /**
   * Update the JSON payload when an event is selected
   */
  changeTestEvent: function () {
    const $dropdown = $(this).find('select')

    // Show correct payload tab
    $('[data-tab-view]').removeClass('active')
    $('[data-tab-view="' + $dropdown.val() + '"]').addClass('active')
  },

  /**
   * Send a test request to the webhook URL
   * @param  {Object} event Jquery event
   */
  test: function (event) {
    event.preventDefault()

    // Validate webhook URL
    const $url = $('.js-webhook-url')
    if (isURL($url.val())) {
      Forms.removeError($url.parents('.c-form-row'))

      const $button = $(this)
      $button.addClass('is-loading')

      // Send test request
      $.ajax({
        type: 'POST',
        url: $(this).attr('href'),
        data: $(this).parents('form').serialize(),
      })
        .done(function (response) {
          if (response.status_code >= 200 && response.status_code < 300) {
            MessageOverlay.show(
              '<span class="webhook-status-badge webhook-status-badge--success">' +
                response.status_code +
                '</span> Your Webhook URL responded successfully.'
            )
          } else {
            const message =
              response.message || 'Your Webhook URL responded with an error.'
            MessageOverlay.show(
              '<span class="webhook-status-badge webhook-status-badge--error">' +
                response.status_code +
                '</span> ' +
                message,
              'error'
            )
          }
        })
        .fail(function () {
          MessageOverlay.show(
            'Uh oh. Something went wrong. Try testing your Webhook URL again.',
            'error'
          )
        })
        .always(function () {
          $button.removeClass('is-loading')
        })
    } else {
      Forms.showError(
        $url.parents('.c-form-row'),
        'Please enter a valid webhook URL.'
      )

      // Scroll to the top of the page
      $('html, body').animate({ scrollTop: 0 })
    }
  },

  /**
   * Generate markup for the webhook test response label
   * @param  {String}  status  Status type (success, error)
   * @param  {Integer} code    HTTP status code
   * @param  {String}  label   Label text
   * @return {Object}          jQuery DOM element
   */
  testResponseLabel: function (status, code, label) {
    const $html = $('<span />').addClass(
      'webhook-status webhook-status--full webhook-status--' + status
    )
    const $code = $('<span />').addClass('webhook-status_code').text(code)
    const $message = $('<span />')
      .addClass('webhook-status_message')
      .text(label)

    $html.append($code)
    $html.append($message)

    return $html
  },
}

$(Webhooks.init)
